<template>
  <a-modal
    :title="titleText"
    :visible="visible"
    :confirm-loading="confirmLoading"
    @cancel="handleCancel"
  >
    <!-- 提示文本 -->
    <p class="modalText">{{ modalText }}</p>
    <!-- 底部按钮 -->
    <template slot="footer">
      <a-button v-if="modalType === 'confirm'" key="back" @click="handleCancel"
      >取消
      </a-button
      >
      <a-button
        key="submit"
        type="primary"
        :loading="confirmLoading"
        @click="handleOk"
      >
        确定
      </a-button>
    </template>
  </a-modal>
</template>
<script>
export default {
  name: "Modal", // 提示弹出框
  props: {
    // 提示文本
    modalText: {
      type: String,
      default: "提示文本"
    },
    // 头部文本
    titleText: {
      type: String,
      default: "提示"
    },
    modalType: {
      // confirm 确认框   remind 提醒框
      type: String,
      default: "confirm"
    }
  },
  data() {
    return {
      visible: false,
      confirmLoading: false
    };
  },
  methods: {
    // 确定
    handleOk() {
      if (this.modalType === "confirm") {
        this.confirmLoading = true;
        this.$emit("handleOk");
        this.confirmLoading = false;
      }
      this.visible = false;
    },
    // 取消
    handleCancel() {
      this.visible = false;
    }
  }
};
</script>

<style lang="less" scoped>
/deep/ .ant-modal-wrap {
  display: flex;
  align-items: center;
}

/deep/ .ant-modal {
  width: 620px !important;
  height: 350px !important;
  overflow: hidden !important;
  top: 0 !important;
  border-radius: 20px;
}

/deep/ .ant-modal-content {
  width: 620px !important;
  height: 350px !important;
  border-radius: 20px;

  .ant-modal-close-x {
    margin-right: 10px;
    margin-top: 10px;
    font-size: 24px;
  }

  .ant-modal-body {
    padding-top: 60px !important;
  }

  .ant-modal-header {
    display: flex;
    align-items: center;
    padding: 0 !important;
    margin: 16px 24px;
    margin-bottom: 0;
    padding-bottom: 16px;
    height: 74px;

    .ant-modal-title {
      font-weight: 600;
      font-size: 24px;
      color: #333333;
    }
  }

  .ant-modal-footer {
    display: flex;
    justify-content: center;
    position: absolute;
    bottom: 50px;
    width: 100%;
    border: 0;

    .ant-btn {
      width: 160px;
      height: 40px;
      border-radius: 20px;
      border: 1px solid #2abded;
      font-size: 16px;
      color: #2abded;
    }

    .ant-btn-primary {
      color: #fff;
      background: #2abded;
    }

    button + button {
      margin-left: 31px !important;
    }
  }
}

.modalText {
  font-size: 20px;
  color: #333333;
  text-align: center;
}
</style>
